import { TextButton } from '@creditornot/cb-button';
import { Cross } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  title?: string;
  closeIcon?: React.ReactNode;
  hasCloseButton?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
};

const Root = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  padding: 24px 16px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  z-index: 1;
  background-color: ${color.bg};
`;

const Header = styled(T.Title1)`
  display: flex;
  font-weight: 700;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const Main = styled.div`
  flex: 1;
  overflow: auto;
`;

export const ImageGalleryHeader = ({ title, onClose, hasCloseButton, closeIcon = <Cross />, children }: Props) => {
  const intl = useIntl();
  const history = useHistory();
  const handleExitButtonClicked = () => {
    if (onClose) {
      onClose();
    } else {
      history.goBack();
    }
  };

  return (
    <Root>
      <Header>
        {hasCloseButton && (
          <TextButton variant="neutral" size="small" icon={closeIcon} onClick={handleExitButtonClicked} />
        )}
        {title ?? intl.formatMessage({ id: 'shared-menu.editor.image-gallery.title' })}
      </Header>
      <ButtonsContainer>{children}</ButtonsContainer>
    </Root>
  );
};
